import React from 'react';
import PropTypes from 'prop-types';
import { Switch } from '@fiverr-private/fit';

const SwitchContainer = ({ value, id, onChange, disabled = false }) => {
    const onChangeHandler = ({ target }) => {
        if (disabled) {
            return;
        }
        onChange(id, target.checked ? true : undefined);
    };

    return <Switch checked={!!value} onChange={onChangeHandler} disabled={disabled} />;
};

SwitchContainer.defaultProps = {
    onChange: (id, value) => ({ id, value }),
    disabled: false,
};

SwitchContainer.propTypes = {
    id: PropTypes.string,
    value: PropTypes.string,
    onChange: PropTypes.func,
    disabled: PropTypes.bool,
};

export default SwitchContainer;
